import { render, staticRenderFns } from "./orderEditGoodsDialog.vue?vue&type=template&id=74742a69&"
import script from "./orderEditGoodsDialog.vue?vue&type=script&lang=js&"
export * from "./orderEditGoodsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports